import { atom } from 'jotai';

export const mightNeedToRefreshAppointmentListAtom = atom(false);
